//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "ConfigRole",
  data() {
    return {
      authData: [],
      checkedAuthData: [],
      defaultProps: {
        children: "children",
        label: "menuName",
      },
      selectedAuth: [],
      activeNames: [],
    };
  },
  props: {
    dialogConfigRoleAuthVisible: {
      type: Boolean,
      default: () => true,
    },
    curRoleDetail: {
      type: Object,
      default: () => {},
    },
    systemType: {
      type: Number,
      default: 2,
    },
  },
  components: {},
  computed: {},
  methods: {
    close(showType) {
      this.$emit("close", "dialogConfigRoleAuthVisible", showType);
    },
    handleCheckChange(data, checked, indeterminate) {
      let selectedAuth = this.$refs.tree.getCheckedNodes();
      this.selectedAuth = selectedAuth.filter((item) => {
        return item.menuType == 4;
      });
    },
    /**
     * @descripttion: 保存配置角色权限
     * @Author: juanjuanhui
     * @Date: 2022-02-25 09:36:39
     */
    async handleSaveConfigRoleAuth() {
      let tempAry = this.$refs.tree
        .getCheckedNodes()
        .concat(this.$refs.tree.getHalfCheckedNodes());
      let sRefRoleMenuButtonDtos = [];
      tempAry.forEach((item) => {
        let roleMenuButtonDtos = {};
        if (item.type == 2) {
          roleMenuButtonDtos.menuId = item.parentId;
          roleMenuButtonDtos.buttonId = item.id;
        } else {
          roleMenuButtonDtos.menuId = item.id;
        }
        sRefRoleMenuButtonDtos.push(roleMenuButtonDtos);
      });
      let params = {
        id: this.curRoleDetail.id,
        sRefRoleMenuButtonDtos,
      };
      try {
        let { status } = await this.$http.role.setMenuForRole({
          ...params,
          systemType: this.systemType,
        });
        if (status == 1) {
          this.$message({
            type: "success",
            message: "角色配置权限成功",
            duration: 2000,
          });
          this.close();
        }
      } catch (error) {}
    },
    /**
     * @description: 删除角色
     * @Author: yangsibo
     * @Date: 2022-05-24 11:26:32
     * @return {*}
     */
    deleteSide() {
      this.close("dialogRemoveRoleVisible");
    },
    /**
     * @description: 获取选择权限
     * @Author: yangsibo
     * @Date: 2022-05-25 09:32:54
     * @return {*}
     */
    async selectSMenuTree() {
      this.authData = [];
      try {
        let { data } = await this.$http.common.selectSMenuTree({
          roleIdList: [this.curRoleDetail.id],
          systemType: this.systemType,
        });
        if (data) {
          this.authData = data;
          this.checkedAuthData = [];
          this.setCheckedAuthData(data);
          setTimeout(() => {
            let selectedAuth = this.$refs.tree.getCheckedNodes();
            this.selectedAuth = selectedAuth.filter((item) => {
              return item.menuType == 4;
            });
          }, 0);
        }
      } catch (error) {}
    },
    /**
     * @description:设置选中权限数据
     * @Author: yangsibo
     * @Date: 2022-05-26 10:31:03
     * @param {*} data
     */
    setCheckedAuthData(data) {
      data.forEach((item) => {
        if (item.selectedFlag) {
          this.checkedAuthData.push(item.id);
        }
        if (item.children) {
          this.setCheckedAuthData(item.children);
        }
      });
    },
  },
  created() {},
  mounted() {
    this.selectSMenuTree();
  },
};
